import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getDriverOrders } from "services/driverService";
import { orderStatus } from "enums/shared";
import { useRTL } from "hooks/isRTL";
import OrdersTabShared from "./OrdersTabShared";

const DriverOrdersTab = () => {
  const { t } = useRTL();
  const { driverId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const queryState = location.state || {};
  const initialStatus = queryState.status
    ? Array.isArray(queryState.status)
      ? queryState.status[0]
      : Object.entries(orderStatus).find(
          ([, value]) => value.value === queryState.status
        )?.[0]
    : null;

  const columns = [
    { id: "orderNumber", label: t("orderNumber"), sortable: true },
    { id: "senderName", label: t("senderName"), sortable: true },
    { id: "receiverName", label: t("receiverName"), sortable: true },
    { id: "pickUpLocation", label: t("pickUpLocation"), sortable: true }, 
    { id: "pickupDateTime", label: t("pickupDateTime"), sortable: true },
    { id: "dropOffLocation", label: t("dropOffLocation"), sortable: true }, 
    { id: "dropOffDateTime", label: t("dropOffDateTime"), sortable: true },
    {
      id: "status",
      label: t("orderStatus"),
      sortable: true,
      name: "orderStatus",
    },
  ];

  return (
    <OrdersTabShared
      id={driverId}
      fetchFn={getDriverOrders}
      queryKey="driverOrders"
      columns={columns}
      initialStatus={initialStatus}
      navigateToOrderDetails={(orderId) => navigate(`/orders/${orderId}`)}
      ClearFilterButton={true}
    />
  );
};

export default DriverOrdersTab;
